










































































import Vue from 'vue'
import Component from 'vue-class-component'
import Card from '@/components/Card.vue'
import Icon from '@/components/Icon.vue'
import { getModule } from 'vuex-module-decorators'
import { ChainModule } from '@/store/modules/chain.module'
import { UserModule } from '@/store/modules/user.module'
import { EAdminTaskStatus, IAdminTask } from '@zunta/configurations'
import { getFilePathByKey } from '@/utils/helpers'
import ScrollView from '@/components/ScrollView.vue'
import TaskDetails from './TaskDetails.vue'
import Avatar from '@/components/Avatar.vue'

const sortBy = require('lodash.sortby')

@Component({
  props: {
    type: {
      type: String,
      default: 'chain'
    }
  },
  components: {
    Card,
    Avatar,
    Icon,
    ScrollView,
    TaskDetails
  }
})
export default class AllTasks extends Vue {
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store);
  userModuleInstance: UserModule = getModule(UserModule, this.$store);
  EAdminTaskStatus: any = EAdminTaskStatus;
  getFilePathByKey: Function = getFilePathByKey;
  taskIndex: number = 0;

  get tasks () {
    return sortBy(this.$store.state.chain.adminTasks, (task: IAdminTask) => {
      return task.status === EAdminTaskStatus.TODO ? 0 : 1
    })
  }

  get currentTask () {
    return this.tasks[this.taskIndex]
  }

  mounted () {
    this.$eventBus.$emit('Root:disableScroll')
    this.fetchHistory()
  }
  beforeDestroy () {
    this.$eventBus.$emit('Root:enableScroll')  
  }

  async fetchHistory () {
    if (this.currentTask) {
      await this.chainModuleInstance.fetchAdminTaskHistories(this.currentTask.id)
    }
  }

  activateTask (index: number) {
    this.taskIndex = index
    this.$nextTick(() => {
      this.fetchHistory()
    })
  }

  getTaskStatusLabel (status: EAdminTaskStatus) {
    switch (status) {
      case EAdminTaskStatus.COMPLETE:
        return 'Complete'
      case EAdminTaskStatus.TODO: 
        return 'To Do'
      default:
        return 'Unknown'
    }
  }
}
